<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-1">Gestão de EPI's</p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-4 col-xs">
        <div class="q-ml-sm titulo-input texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="recebeUnidade.unidade"
          class="input-new-design"
        ></lista-unidades-select>
      </div>
      <div v-if="botaoListagemCa" class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Status (CA)</div>
        <q-input
          label="Digite o Status do CA"
          class="input input-new-design"
          v-model="codigo"
          dense
          outlined
        />
      </div>
      <div v-if="botaoListagemCa" class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Buscar Por (CA)</div>
        <q-input
          label="Digite o CA"
          class="input input-new-design"
          v-model="codigo"
          dense
          outlined
        />
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-lg container-btns"
    >
      <div>
        <q-btn
          :class="{ botaoListagemCa: botaoListagemCa }"
          icon="list"
          label="Produtos com (CA Vinculado)"
          no-caps
          style="color: #5e70a2"
          outline
          class="btn"
          @click="
            (botaoListagemCa = true),
              (botaoCriarCa = false),
              (botaoAtualizarCa = false)
          "
        />
      </div>
      <div>
        <q-btn
          :class="{ botaoCriarCa: botaoCriarCa }"
          icon="add"
          label="Criar / Atualizar C.A"
          no-caps
          class="btn"
          outline
          style="color: #58c16d"
          @click="
            (botaoCriarCa = true),
              (botaoListagemCa = false),
              (botaoAtualizarCa = false)
          "
        />
      </div>
    </div>
    <div
      v-if="botaoListagemCa"
      style="width: 25%"
      class="col-md-6 col-sm-4 col-xs q-mt-md"
    >
      <div class="q-ml-sm text-brand-5 text-weight-bold texto-titulo-input">
        Selecionar CA
      </div>
      <q-select
        dense
        outlined
        v-model="model"
        use-input
        hide-selected
        fill-input
        class="select input-new-design"
        input-debounce="0"
        :options="options"
        @filter="filterFn"
      >
        <q-tooltip anchor="top middle" self="bottom middle"
          >Aqui você seleciona um CA para vincular a o produto</q-tooltip
        >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-grey">Sem resultados</q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
    <ListaVincularCa v-if="botaoListagemCa" :ca="model" @limpar="reset()" />

    <AtualizarECriarCa v-if="botaoCriarCa" :botaoTipo="'criar'" />
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";

import ListaVincularCa from "../components/ListaVincularCa.vue";
import AtualizarECriarCa from "../components/AtualizarECriarCa.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaVincularCa, AtualizarECriarCa, ListaUnidadesSelect },
  setup() {
    const store = useStore();

    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const options = ref([]);
    const timer = ref(null);
    const timer2 = ref(null);
    const time = ref();
    let model = ref(null);
    let botaoListagemCa = ref(true);
    let botaoCriarCa = ref(false);
    let botaoAtualizarCa = ref(false);

    const listarCas = async (val) => {
      options.value = [];
      try {
        let response = await store.dispatch("produtos/listarCas", {
          code: val,
        });
        response.data.results.data.forEach((ca) => {
          options.value.push({
            value: ca.id,
            label: `${ca.code}-${ca.status}`,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const reset = async () => {
      model.value = null;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      recebeUnidade,
      timer,
      timer2,
      options,
      filterFn(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarCas(val);
        }, 2000);

        setTimeout(() => {
          update(() => {
            const needle = val.toLowerCase();
            options.value = options.value.filter((v) => {
              v.label.toLowerCase().indexOf(needle) > -1;
              return v;
            });
          });
        }, 2500);
      },
      model,
      botaoListagemCa,
      botaoCriarCa,
      botaoAtualizarCa,
      reset,
      time,
    };
  },
};
</script>

<style scoped>
.botaoListagemCa {
  color: white !important;
  background-color: #5e70a2 !important;
}
.botaoCriarCa {
  color: white !important;
  background-color: #58c16d !important;
}
.botaoAtualizarCa {
  color: white !important;
  background-color: #2b5070 !important;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .select {
    font-size: 12px;
  }
  .container-inputs {
    margin: 8px 0px 0px 0px;
    padding: 0px;
  }
  .btn {
    font-size: 12px;
    border-radius: 5px;
  }
  .container-btns {
    margin: 20px 0px 0px 0px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
.titulo-input {
  color: #213864;
}
</style>
